import { render, staticRenderFns } from "./SmallOverlay.html?vue&type=template&id=3350e68c&scoped=true&"
import script from "./SmallOverlay.js?vue&type=script&lang=js&"
export * from "./SmallOverlay.js?vue&type=script&lang=js&"
import style0 from "./SmallOverlay.scss?vue&type=style&index=0&id=3350e68c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3350e68c",
  null
  
)

export default component.exports